import type { BeneficiariesListResponse, BeneficiaryResponse, BeneficiaryPerson } from '../../api/models/bff/Beneficiary';
import { generateId } from '../utils/generators';

export function createMockBeneficiaryPerson(overrides?: Partial<BeneficiaryPerson>): BeneficiaryPerson {
  return {
    id: generateId('person'),
    firstName: 'Jane',
    lastName: 'Doe',
    email: 'jane.doe@example.com',
    dateOfBirth: '1990-05-15',
    gender: 'FEMALE',
    currency: 'EUR',
    locale: 'en-US',
    nationality: 'US',
    country: 'US',
    ...overrides,
  };
}

export function createMockBeneficiary(overrides?: Partial<BeneficiaryResponse>): BeneficiaryResponse {
  const subscriptionId = generateId('sub');
  return {
    id: generateId('ben'),
    relationship: 'SPOUSE',
    subscriptionId,
    createdAt: '2025-01-10T10:00:00Z',
    updatedAt: '2025-01-10T10:00:00Z',
    person: createMockBeneficiaryPerson(),
    isDeletable: true,
    deletableAt: '2025-01-15T10:00:00Z',
    ...overrides,
  };
}

export function createMockBeneficiaries(subscriptionId: string, overrides?: Partial<BeneficiariesListResponse>): BeneficiariesListResponse {
  return {
    beneficiaries: [
      createMockBeneficiary({
        id: 'ben-001',
        subscriptionId,
        relationship: 'SPOUSE',
        person: createMockBeneficiaryPerson({
          id: 'person-001',
          firstName: 'Jane',
          lastName: 'Doe',
          email: 'jane.doe@example.com',
          dateOfBirth: '1990-05-15',
          gender: 'FEMALE',
          nationality: 'US',
          country: 'US',
        }),
        isDeletable: true,
      }),
      createMockBeneficiary({
        id: 'ben-002',
        subscriptionId,
        relationship: 'CHILD',
        person: createMockBeneficiaryPerson({
          id: 'person-002',
          firstName: 'John',
          lastName: 'Doe',
          email: 'john.doe@example.com',
          dateOfBirth: '2015-08-22',
          gender: 'MALE',
          nationality: 'US',
          country: 'US',
        }),
        isDeletable: false,
      }),
    ],
    maxBeneficiariesAllowed: 4,
    ...overrides,
  };
}
